(() => {
  const config = document.querySelector('[data-mova-video-sound]');
  if (!config) return;
  const videos = new WeakMap();
  const icon = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path class="mvs__waves" d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/><path class="mvs__slash" d="m15 9 6 6m0-6-6 6"/></svg>';
  function attach(video) {
    if (videos.has(video) || !video.parentElement) return;
    const host = video.parentElement;
    if (getComputedStyle(host).position === 'static') host.classList.add('mvs-host');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mvs-button';
    button.innerHTML = icon + '<span></span>';
    const label = button.querySelector('span');
    const update = () => {
      const audible = !video.muted && video.volume > 0;
      button.dataset.audible = String(audible);
      button.dataset.nativeControls = String(video.controls);
      button.setAttribute('aria-pressed', String(audible));
      button.setAttribute('aria-label', audible ? config.dataset.mute : config.dataset.unmute);
      label.textContent = audible ? config.dataset.muteLabel : config.dataset.unmuteLabel;
    };
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (video.muted || video.volume === 0) {
        document.querySelectorAll('video').forEach(other => { if (other !== video) other.muted = true; });
        if (video.volume === 0) video.volume = 1;
        video.muted = false;
        if (video.paused) video.play().catch(() => {});
      } else video.muted = true;
      update();
    });
    video.addEventListener('volumechange', update);
    video.addEventListener('loadedmetadata', update);
    videos.set(video, button);
    host.append(button);
    update();
  }
  const scan = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('video')) attach(root);
    root.querySelectorAll('video').forEach(attach);
  };
  scan(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, { childList: true, subtree: true });
})();
